<template>
  <div ref="node" class="flex flex-col items-center px-4 py-2 bg-white rounded shadow mb-4">
    <!-- 節點標題 -->
    <span class="font-bold mb-2">Node {{ Array.isArray(node) ? "Group" : node }}</span>

    <!-- 節點資料展示 -->
    <div v-if="Array.isArray(node)" class="flex flex-wrap space-x-4 mb-2">
      <div
        v-for="(item, idx) in node"
        :key="idx"
        class="flex flex-col items-center border p-2 rounded"
      >
        <span>{{ item }}</span>
        <!-- 選單設定 -->
        <select class="border rounded px-2 py-1 mt-1">
          <option value="" disabled selected>Option 1</option>
          <option v-for="option in options1" :key="option" :value="option">{{ option }}</option>
        </select>
        <select class="border rounded px-2 py-1 mt-1">
          <option value="" disabled selected>Option 2</option>
          <option v-for="option in options2" :key="option" :value="option">{{ option }}</option>
        </select>
        <!-- 刪除資料按鈕 -->
        <button
          @click="deleteNodeData(idx)"
          class="mt-2 bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
        >
          Delete Data
        </button>
      </div>
    </div>

    <!-- 操作按鈕 -->
    <div class="flex space-x-2">
      <button
        @click="addNextStage"
        class="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
      >
        Add Next Stage
      </button>
      <button
        @click="addCurrentNodeData"
        class="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
      >
        Add Node Data
      </button>
      <button
        @click="deleteCurrentNode"
        class="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
      >
        Delete Node
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    node: {
      type: [Number, Array],
      required: true,
    },
    groupIndex: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // 選單的選項資料
      options1: ["Option 1-A", "Option 1-B", "Option 1-C"],
      options2: ["Option 2-X", "Option 2-Y", "Option 2-Z"],
    };
  },
  methods: {
    // 新增下一階段節點
    addNextStage() {
      this.$emit("add-next-stage", this.groupIndex, this.index);
    },
    // 新增目前節點的資料
    addCurrentNodeData() {
      this.$emit("add-current-node-data", this.groupIndex, this.index);
    },
    // 刪除目前節點
    deleteCurrentNode() {
      this.$emit("delete-node", this.groupIndex, this.index);
    },
    // 刪除節點中的資料
    deleteNodeData(subIndex) {
      this.$emit("delete-node", this.groupIndex, this.index, subIndex);
    },
  },
};
</script>

<style scoped>
.shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
